import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "barPercentageChart",
  props: {
    bpcPercentage: {
      type: Number,
      required: true,
    },
  },

  setup(props, _ctx) {
    const strDashArray = computed(() => {
      return `${props.bpcPercentage}, 100`;
    });

    const percentageLabel = computed(() => {
      return `${props.bpcPercentage} %`;
    });

    return {
      strDashArray,
      percentageLabel,
    };
  },
});
